import { ck } from "fire-wind-water/cookie";
import { URLS } from "fire-wind-water/url";
import { interact } from "fire-wind-water/tools/interact";
import URL from "../assets/conf/setting.json";
import { createField, updateDirty } from "../../stempcore/src/core/sfield";
import { resetURL, setUploadURL, setURL } from "../../stempcore/src/sbase";

ck.json = true;
const tenantId = URLS.getURL("tenantId");
const schemaId = URLS.getURL("schemaId") || URLS.getURL("memberSchemaId");
const memberFormId = URLS.getURL("memberFormId");
const userInfo = ck.cookie(`smarketMember_${schemaId}`);
const sess = userInfo ? userInfo.session : null;
const fileUrl = URL.sbaseUrl;
const ow365Url = URL.officePrefixUrl || "";
resetURL(URL);
setUploadURL(URL.template.api.ungateway.contentUrl);
setURL(URL.template.api.gateway.general + "/");

let memberFormInfo = null;
export const domain = window.$sk.config.domain;
export function setMemberFormInfo(o) {
  memberFormInfo = o;
}
export function logout() {
  if (!memberFormInfo) {
    return;
  }
  ck.removeCookie(`smarketMember_${schemaId}`, {
    domain: domain
  });
  if (interact.isMobile == 1) {
      window.$sk.goto(memberFormInfo.originUrl.wap +
          "&backUrl=" +
          encodeURIComponent(window.location.href));
  } else {
      window.$sk.goto(memberFormInfo.originUrl.pc +
          "&backUrl=" +
          encodeURIComponent(window.location.href));
  }
}
export {
  tenantId,
  schemaId,
  memberFormId,
  userInfo,
  sess,
  fileUrl,
  ow365Url,
  createField,
  updateDirty
};
